import React, { useState } from 'react';
import Brokoli from '../../assets/images/brokoli.png';
import JagungManis from "../../assets/images/sayur/buah/jagung.jpeg";
import Wortel from "../../assets/images/sayur/akar/wortel.jpeg";
import Daging from "../../assets/images/daging/sapi.jpeg";
import Kentank from "../../assets/images/sayur/umbi/kentang.jpeg";

import PopupAddingProduct from '../../components/Merchandise/PopupAddingProduct';

const TableProduct = () => {
  const [addProductPopup, setAddProductPopup] = useState(false);
  const [toggleDeleteBtnIndex, setToggleDeleteBtnIndex] = useState(null);

  function handleShowPopupProduct() {
    setAddProductPopup(!addProductPopup);
  }
  const toggleDelete = (deleteIndex) => {
    if (toggleDeleteBtnIndex === deleteIndex) setToggleDeleteBtnIndex(null);
    else setToggleDeleteBtnIndex(deleteIndex);
  };
  return (
    <div className="bg-white">
      <div className="py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 pr-10 lg:px-8">
        <div className="align-middle rounded-tl-lg rounded-tr-lg inline-block w-full py-4 overflow-hidden bg-white shadow-lg px-12"></div>
        <div className="align-middle inline-block w-full shadow overflow-hidden bg-white shadow-dashboard px-8 pt-3 rounded-bl-lg rounded-br-lg">
          {addProductPopup ? (
            <PopupAddingProduct handdleClick={handleShowPopupProduct} />
          ) : null}
          <table className="w-full">
            <thead>
              <tr>
                <th className="bg-gray-300 px-8 py-4 border-b-2 border-gray-100 text-left leading-4 text-gray-600 tracking-wider">
                  Gambar
                </th>
                <th className="bg-gray-300 px-8 py-4 border-b-2 border-gray-100 text-left leading-4 text-gray-600 tracking-wider">
                  Nama Produk
                </th>
                <th className="bg-gray-300 px-8 py-4 border-b-2 border-gray-100 text-left leading-4 text-gray-600 tracking-wider">
                  Satuan
                </th>
                <th className="bg-gray-300 px-8 py-4 border-b-2 border-gray-100 text-left leading-4 text-gray-600 tracking-wider">
                  Harga Jual
                </th>
                <th className="bg-gray-300 px-8 py-4 border-b-2 border-gray-100 text-left leading-4 text-gray-600 tracking-wider">
                  Modal
                </th>
                <th className="bg-gray-300 px-8 py-4 border-b-2 border-gray-100 text-left leading-4 text-gray-600 tracking-wider">
                  Diskon
                </th>
                <th className="bg-gray-300 px-8 py-4 border-b-2 border-gray-100 text-left leading-4 text-gray-600 tracking-wider">
                  Stok
                </th>
                <th className="bg-gray-300 px-8 py-4 border-b-2 border-gray-100 text-left leading-4 text-gray-600 tracking-wider">
                  Tindakan
                </th>
              </tr>
            </thead>
            <tbody className="bg-white">
              <tr>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100">
                  <div className="flex items-center">
                    <div>
                      <div className="text-sm leading-5 text-gray-800">
                        <img alt="Brokoli" className="ml-4 my-2 h-16" src={Brokoli}></img>
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100">
                  <div className="text-sm leading-5 text-gray-600">
                    Brokoli bang
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b text-blue-900 border-gray-100 text-sm leading-5">
                  250g
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b text-blue-900 border-gray-100 text-sm leading-5">
                  Rp 10.000
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b text-blue-900 border-gray-100 text-sm leading-5">
                  Rp 20.000
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100 text-gray-600 text-sm leading-5">
                  Rp 5000
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100 text-gray-600 text-sm leading-5">
                  100
                </td>
                <th className="px-6 py-4 whitespace-no-wrap text-right border-b border-gray-100 text-sm leading-5">
                  <td className="  px-6 py-4 text-left leading-4 text-gray-600 tracking-wider ">
                    <div className="flex w-full items-center justify-center">
                      <div className="relative inline-block">
                        {/* Dropdown Address */}
                        {toggleDeleteBtnIndex === 1 && (
                          <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                            <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                              <div
                                className="py-1"
                                role="menu"
                                aria-orientation="vertical"
                                aria-labelledby="options-menu"
                              >
                                <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                                  <p className="text-sm font-semibold">
                                    Yakin Ingin menghapus Brokoli ?
                                  </p>
                                  <div className="flex ml-auto mt-6">
                                    <button
                                      className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                      onClick={() => {
                                        toggleDelete(1);
                                      }}
                                    >
                                      Tidak
                                    </button>
                                    <button
                                      className="text-sm text-white bg-green-700 border border-bg-green-700 px-3 py-1 rounded"
                                      onClick={() => {
                                        toggleDelete(1);
                                      }}
                                    >
                                      Ya
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {/* End Dropdown Address */}
                        <button
                          className="mx-1"
                          onClick={() => {
                            toggleDelete(1);
                          }}
                        >
                          <img
                            src="/assets/icon/trash-can.svg"
                            className="h-5"
                            alt=""
                          />
                        </button>
                      </div>

                      <hr className="mx-1 border-r border-gray-100 h-5" />
                      <button
                        onClick={() => {
                          handleShowPopupProduct(!addProductPopup);
                        }}
                      >
                        <button className="mx-1">
                          <img
                            src="/assets/icon/bxs-pencil.svg"
                            className="h-5"
                            alt=""
                          />
                        </button>
                      </button>
                    </div>
                  </td>
                </th>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100">
                  <div className="flex items-center">
                    <div>
                      <div className="text-sm leading-5 text-gray-800">
                        <img alt="Jagung Maniz" className="ml-4 my-2 h-16" src={JagungManis}></img>
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100">
                  <div className="text-sm leading-5 text-gray-600">
                    Jagung Manis
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b text-blue-900 border-gray-100 text-sm leading-5">
                  250g
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b text-blue-900 border-gray-100 text-sm leading-5">
                  Rp 10.000
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b text-blue-900 border-gray-100 text-sm leading-5">
                  Rp 20.000
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100 text-gray-600 text-sm leading-5">
                  Rp 5000
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100 text-gray-600 text-sm leading-5">
                  100
                </td>
                <th className="px-6 py-4 whitespace-no-wrap text-right border-b border-gray-100 text-sm leading-5">
                  <td className="  px-6 py-4 text-left leading-4 text-gray-600 tracking-wider ">
                    <div className="flex w-full items-center justify-center">
                      <div className="relative inline-block">
                        {/* Dropdown Delete */}
                        {toggleDeleteBtnIndex === 2 && (
                          <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                            <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                              <div
                                className="py-1"
                                role="menu"
                                aria-orientation="vertical"
                                aria-labelledby="options-menu"
                              >
                                <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                                  <p className="text-sm font-semibold">
                                    Yakin Ingin menghapus Brokoli ?
                                  </p>
                                  <div className="flex ml-auto mt-6">
                                    <button
                                      className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                      onClick={() => {
                                        toggleDelete(2);
                                      }}
                                    >
                                      Tidak
                                    </button>
                                    <button
                                      className="text-sm text-white bg-green-700 border border-bg-green-700 px-3 py-1 rounded"
                                      onClick={() => {
                                        toggleDelete(2);
                                      }}
                                    >
                                      Ya
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {/* End Dropdown Delete */}
                        <button
                          className="mx-1"
                          onClick={() => {
                            toggleDelete(2);
                          }}
                        >
                          <img
                            src="/assets/icon/trash-can.svg"
                            className="h-5"
                            alt=""
                          />
                        </button>
                      </div>

                      <hr className="mx-1 border-r border-gray-100 h-5" />
                      <button
                        onClick={() => {
                          handleShowPopupProduct(!addProductPopup);
                        }}
                      >
                        <button className="mx-1">
                          <img
                            src="/assets/icon/bxs-pencil.svg"
                            className="h-5"
                            alt=""
                          />
                        </button>
                      </button>
                    </div>
                  </td>
                </th>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100">
                  <div className="flex items-center">
                    <div>
                      <div className="text-sm leading-5 text-gray-800">
                        <img alt="Wortel" className="ml-4 my-2 h-16" src={Wortel}></img>
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100">
                  <div className="text-sm leading-5 text-gray-600">
Daging Sapi                  </div>
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b text-blue-900 border-gray-100 text-sm leading-5">
                  250g
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b text-blue-900 border-gray-100 text-sm leading-5">
                  Rp 10.000
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b text-blue-900 border-gray-100 text-sm leading-5">
                  Rp 20.000
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100 text-gray-600 text-sm leading-5">
                  Rp 5000
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100 text-gray-600 text-sm leading-5">
                  100
                </td>
                <th className="px-6 py-4 whitespace-no-wrap text-right border-b border-gray-100 text-sm leading-5">
                  <td className="  px-6 py-4 text-left leading-4 text-gray-600 tracking-wider ">
                    <div className="flex w-full items-center justify-center">
                      <div className="relative inline-block">
                        {/* Dropdown Address */}
                        {toggleDeleteBtnIndex === 3 && (
                          <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                            <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                              <div
                                className="py-1"
                                role="menu"
                                aria-orientation="vertical"
                                aria-labelledby="options-menu"
                              >
                                <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                                  <p className="text-sm font-semibold">
                                    Yakin Ingin menghapus Brokoli ?
                                  </p>
                                  <div className="flex ml-auto mt-6">
                                    <button
                                      className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                      onClick={() => {
                                        toggleDelete(3);
                                      }}
                                    >
                                      Tidak
                                    </button>
                                    <button
                                      className="text-sm text-white bg-green-700 border border-bg-green-700 px-3 py-1 rounded"
                                      onClick={() => {
                                        toggleDelete(3);
                                      }}
                                    >
                                      Ya
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {/* End Dropdown Address */}
                        <button
                          className="mx-1"
                          onClick={() => {
                            toggleDelete(3);
                          }}
                        >
                          <img
                            src="/assets/icon/trash-can.svg"
                            className="h-5"
                            alt=""
                          />
                        </button>
                      </div>

                      <hr className="mx-1 border-r border-gray-100 h-5" />
                      <button
                        onClick={() => {
                          handleShowPopupProduct(!addProductPopup);
                        }}
                      >
                        <button className="mx-1">
                          <img
                            src="/assets/icon/bxs-pencil.svg"
                            className="h-5"
                            alt=""
                          />
                        </button>
                      </button>
                    </div>
                  </td>
                </th>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100">
                  <div className="flex items-center">
                    <div>
                      <div className="text-sm leading-5 text-gray-800">
                        <img alt="Daging" className="ml-4 my-2 h-16" src={Daging}></img>
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100">
                  <div className="text-sm leading-5 text-gray-600">
                    Wortel
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b text-blue-900 border-gray-100 text-sm leading-5">
                  250g
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b text-blue-900 border-gray-100 text-sm leading-5">
                  Rp 10.000
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b text-blue-900 border-gray-100 text-sm leading-5">
                  Rp 20.000
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100 text-gray-600 text-sm leading-5">
                  Rp 5000
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100 text-gray-600 text-sm leading-5">
                  100
                </td>
                <th className="px-6 py-4 whitespace-no-wrap text-right border-b border-gray-100 text-sm leading-5">
                  <td className="  px-6 py-4 text-left leading-4 text-gray-600 tracking-wider ">
                    <div className="flex w-full items-center justify-center">
                      <button className="mx-1">
                        <img
                          src="/assets/icon/trash-can.svg"
                          className="h-5"
                          alt=""
                        />
                      </button>
                      <hr className="mx-1 border-r border-gray-100 h-5" />
                      <button className="mx-1">
                        <img
                          src="/assets/icon/bxs-pencil.svg"
                          className="h-5"
                          alt=""
                        />
                      </button>
                    </div>
                  </td>
                </th>
              </tr>
              <tr>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100">
                  <div className="flex items-center">
                    <div>
                      <div className="text-sm leading-5 text-gray-800">
                        <img alt="Kentang" className="ml-4 my-2 h-16" src={Kentank}></img>
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100">
                  <div className="text-sm leading-5 text-gray-600">
Kentang                  </div>
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b text-blue-900 border-gray-100 text-sm leading-5">
                  250g
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b text-blue-900 border-gray-100 text-sm leading-5">
                  Rp 10.000
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b text-blue-900 border-gray-100 text-sm leading-5">
                  Rp 20.000
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100 text-gray-600 text-sm leading-5">
                  Rp 5000
                </td>
                <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-100 text-gray-600 text-sm leading-5">
                  100
                </td>
                <th className="px-6 py-4 whitespace-no-wrap text-right border-b border-gray-100 text-sm leading-5">
                  <td className="  px-6 py-4 text-left leading-4 text-gray-600 tracking-wider ">
                    <div className="flex w-full items-center justify-center">
                      <button className="mx-1">
                        <img
                          src="/assets/icon/trash-can.svg"
                          className="h-5"
                          alt=""
                        />
                      </button>
                      <hr className="mx-1 border-r border-gray-100 h-5" />
                      <button
                        onClick={() => {
                          handleShowPopupProduct(!addProductPopup);
                        }}
                      >
                        <button className="mx-1">
                          <img
                            src="/assets/icon/bxs-pencil.svg"
                            className="h-5"
                            alt="Edit"
                          />
                        </button>
                      </button>
                    </div>
                  </td>
                </th>
              </tr>
            </tbody>
          </table>

          <div className="sm:flex sm:items-center sm:justify-between mt-4 work-sans float-right">
            <div>
              <nav className="relative z-0 inline-flex shadow-sm">
                <div>
                  <a
                    href="/"
                    className="border-none relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-100 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150"
                    aria-label="Previous"
                  >
                    Sebelumnya
                  </a>
                </div>
                <div>
                  <a
                    href="/"
                    className="border-none relative inline-flex items-center px-4 py-2 border border-gray-100 bg-white text-sm leading-5 font-medium text-green-700 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-tertiary active:text-gray-700 transition ease-in-out duration-150 hover:bg-tertiary"
                  >
                    1
                  </a>
                  <a
                    href="/"
                    className="border-none relative inline-flex items-center px-4 py-2 border border-gray-100 bg-white text-sm leading-5 font-medium text-green-600 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-tertiary active:text-gray-700 transition ease-in-out duration-150 hover:bg-tertiary"
                  >
                    2
                  </a>
                  <a
                    href="/"
                    className="border-none relative inline-flex items-center px-4 py-2 border border-gray-100 bg-white text-sm leading-5 font-medium text-green-600 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-tertiary active:text-gray-700 transition ease-in-out duration-150 hover:bg-tertiary"
                  >
                    3
                  </a>
                </div>
                <div>
                  <a
                    href="/"
                    className="border-none relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-100 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150"
                    aria-label="Next"
                  >
                    Selanjutnya
                  </a>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableProduct;
